// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__32NVU","row":"styles_row__1nHhO"};